import { render, staticRenderFns } from "./zcfg.vue?vue&type=template&id=6db34b26&scoped=true"
import script from "./zcfg.vue?vue&type=script&lang=js"
export * from "./zcfg.vue?vue&type=script&lang=js"
import style0 from "./zcfg.vue?vue&type=style&index=0&id=6db34b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db34b26",
  null
  
)

export default component.exports